module.exports = __webpack_public_path__ + "static/media/marker.2b7c48a7.svg";